import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const patientDemographicsService = {
  basePath: orgId => `${clinicalApiPath}/organizations/${orgId}/patient-demographics`,
  getAllByPatientIdPath: (orgId, patientId) =>
    `${clinicalApiPath}/organizations/${orgId}/patients/${patientId}/patient-demographics`,
  findSingleByPatientIdPrioritizedPath: (orgId, patientId) =>
    `${clinicalApiPath}/organizations/${orgId}/patients/${patientId}/patient-demographics-record`,

  create(orgId, demographics) {
    return viperApi.post(this.basePath(orgId), demographics)
  },

  update(orgId, demographics) {
    return viperApi.put(`${this.basePath(orgId)}/${demographics.id}`, demographics)
  },

  delete(orgId, demographics) {
    return viperApi.delete(`${this.basePath(orgId)}/${demographics.id}`)
  },

  findByPatientId(orgId, patientId) {
    return viperApi.get(this.getAllByPatientIdPath(orgId, patientId))
  },

  findSingleByPatientIdPrioritized(orgId, patientId) {
    return viperApi.get(this.findSingleByPatientIdPrioritizedPath(orgId, patientId))
  }
}
